export default __webpack_public_path__ + "static/media/guest.635114f0.png";